export default __webpack_public_path__ + "static/media/wma.41cbe3f3.svg";